import React from 'react';
import Resource, { ResourceInfo, ResourceProps } from '../../../components/Resource/Resource/Resource';
import { getAdvisorsApiRoot } from '../../../utils/getAdvisorsApiRoot';
import transformAdvisors from './transformAdvisors';
import { AdvisorsDto } from '../../../interfaces/dtos/AdvisorsDto';

export const AdvisorsResourceInfo: ResourceInfo = {
  name: '/App.AdvisorsAdvisorsResource',
  dataDst: '/App.AdvisorsAdvisorsData',
};

const AdvisorsResource = <Data, Error = {}>({ ...props }: ResourceProps<Data, Error>) => {
  const url = `${getAdvisorsApiRoot()}?rel=self&fields=data(id,fullName,phones(tollFree,local),email,agency(address,address2,postalCode,city,state,name,phones(local,tollFree),email))`;

  return (
    <Resource
      {...AdvisorsResourceInfo}
      {...props}
      transformResponse={(data: AdvisorsDto) => {
        if (!data || data?.data?.length === 0) {
          throw new Error('Data is empty');
        }
        return transformAdvisors(data);
      }}
      url={url}
    />
  );
};
export default AdvisorsResource;
